import { render, staticRenderFns } from "./PicChooseWidget.vue?vue&type=template&id=1fa6affd&scoped=true&"
import script from "./PicChooseWidget.vue?vue&type=script&lang=js&"
export * from "./PicChooseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa6affd",
  null
  
)

export default component.exports